var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2936 5.06096C11.6841 4.67044 12.3173 4.67044 12.7078 5.06096L18.8919 11.2451C19.1009 11.4283 19.2329 11.6974 19.2329 11.9972C19.2329 11.9998 19.2329 12.0024 19.2329 12.0049C19.2317 12.2593 19.134 12.5133 18.94 12.7073L12.7078 18.9395C12.3173 19.33 11.6841 19.33 11.2936 18.9395C10.9031 18.549 10.9031 17.9158 11.2936 17.5253L15.8217 12.9972H5.76714C5.21485 12.9972 4.76714 12.5495 4.76714 11.9972C4.76714 11.4449 5.21485 10.9972 5.76714 10.9972H15.8156L11.2936 6.47517C10.9031 6.08465 10.9031 5.45148 11.2936 5.06096Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowRight.0dda6e885d3b76c2dc88b1f8f31d1d3e.svg";